<template>
  <span class="render-kwh">
    {{ format() }}
  </span>
</template>

<script>
import { formatNumberWithThousandSeparator } from '../../utils';
export default {
  props: {
    value: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  methods: {
    format() {
      const integerValue = this.value ? parseInt(this.value, 10) : 0;
      return formatNumberWithThousandSeparator(integerValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.render-kwh {
  text-align: right;
}
</style>
